import * as React from 'react';
import * as styles from './SummaryDesktop.css';
import { ActionButtonsContainer } from '../../../ActionButtons';
import { CheckoutContainer } from '../../../Checkout';
import { MLSNPublicationBannerContainer } from '../../../MLSNPublicationBanner';
import { N1PublicationBannerContainer } from '../../../N1PublicationBanner';
import { VisibleViolationsWarningContainer } from '../../../VisibleViolationsWarning';
import { BalanceDesktop } from '../../../Balance';
import { MoneySourceContainer } from '../../../MoneySource';

interface IProps {
  allowMoneySourceWidget: boolean;
}

export const SummaryDesktop = ({ allowMoneySourceWidget }: IProps) => {
  return (
    <div>
      <N1PublicationBannerContainer />
      <MLSNPublicationBannerContainer />

      <div className={styles['container']}>
        <div>
          {allowMoneySourceWidget && <MoneySourceContainer />}
          <BalanceDesktop />
        </div>

        <div className={styles['checkout']}>
          <CheckoutContainer />
          <VisibleViolationsWarningContainer />
          <ActionButtonsContainer />
        </div>
      </div>
    </div>
  );
};
